import isEmpty from '@/helpers/isEmpty'

const CKE_WRAP_CLASSNAME = 'cke-wrap'

export const ckewrapPlugin: CKEDITOR.pluginDefinition = {
  init: (editor) => {
    editor.on('setData', (event) => {
      const dataValue = event.data.dataValue as unknown

      if (typeof dataValue !== 'string' || isEmpty(dataValue)) {
        return
      }

      const doc = new DOMParser().parseFromString(dataValue, 'text/html')

      const wrapperEl = doc.querySelector(`.${CKE_WRAP_CLASSNAME}`)

      if (!wrapperEl) {
        return
      }

      event.data.dataValue = wrapperEl.innerHTML
    })

    editor.on('getData', (event) => {
      const dataValue = event.data.dataValue as unknown

      if (typeof dataValue !== 'string' || isEmpty(dataValue)) {
        return
      }

      const doc = new DOMParser().parseFromString(dataValue, 'text/html')

      if (doc.body.firstElementChild?.classList.contains(CKE_WRAP_CLASSNAME)) {
        return
      }

      const wrapperEl = doc.createElement('div')

      wrapperEl.className = CKE_WRAP_CLASSNAME

      for (const childNode of doc.body.childNodes) {
        wrapperEl.appendChild(childNode)
      }

      doc.body.appendChild(wrapperEl)

      event.data.dataValue = doc.body.innerHTML.trim()
    })
  },
}
